import Repository from '@/repositories/marketing'
const resource='/sms_contacts'

export default {
	getContactLists(contactId,config){
		return Repository.get(`${resource}/${contactId}/sms_lists.json`, config)
	},
	toggleSubscriptions(contactId, payload, config){
		return Repository.post(`${resource}/${contactId}/toggle_subscriptions.json`,payload,config)
	},
	dnmStatus(contactId, config) {
		return Repository.get(`${resource}/${contactId}/in_dnm.json`, config)
	},
	updateDNMStatus (isDNM, contactId, payload, config) {
		if (isDNM) {
			return Repository.delete(`${resource}/${contactId}/remove_from_dnm.json`, payload, config)
		} else {
			return Repository.post(`${resource}/${contactId}/add_to_dnm.json`, payload, config)
		}
	},
	deleteSmsContact(contactId){
		return Repository.delete(`${resource}/${contactId}.json`)
	},
	getRecentActivities (contactId, config) {
		return Repository.get(`${resource}/${contactId}/recent_activities.json`, config)
	},
	engagementStat (contactId, type, config) {
		return Repository.get(`${resource}/${contactId}/${type}.json`, config)
	},
	fetchsmsContactDetail(contactId, config){
		return Repository.get(`${resource}/${contactId}.json`,config);
	},
	/**
	 * Fetches sms contact top 10 engaging keywords
	 * @returns {Promise} List of most engaging sms keywards
	*/
	smsContactEngagingKeywords(contactId, payload = {}) {
		const endpoint = `${resource}/${contactId}/most_engaging_keywords.json`;
		return Repository.get(endpoint, payload);
	},
	/**
	 * Fetches sms response rate peercentage for a contact
	 * * @returns {Promise} sms response rate percentage
	*/
	smsContactResponseRate(contactId, payload = {}) {
		const endpoint = `${resource}/${contactId}/response_rate.json`;
		return Repository.get(endpoint, payload);
	}
}
